import React, { useState, useEffect } from "react";

import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";

import { urlFor, client } from "../../client";

import { useSelector } from "react-redux";
import "./About.scss";

const About = (props) => {
  const [abouts, setAbouts] = useState([]);
  const { content } = useSelector((state) => state.content);


  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query).then((data) => {
      if (content.tr) {
        let newData = data.filter((about) => about.lang !== "en");
        setAbouts(newData);
      } else {
        let newData = data.filter((about) => about.lang !== "tr");
        setAbouts(newData);
      }
    });
  }, [content]);

  const trContent = (
    <h2 className="head-text">
      <span> 24/7 </span>
      sizi temsil ediyor:
      <br />
      <span> websiteniz </span>
    </h2>
  );

  const enContent = (
    <h2 className="head-text">
      Websites promote you
      <span> 24/7 </span>
      <br />
      <span> No employee </span>
      will do that.
    </h2>
  );

  return (
    <>
      {content.tr && trContent}
      {content.en && enContent}

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.3, type: "tween" }}
            className="app__profile-item"
            key={about?.title + index}
          >
            <img src={urlFor(about?.imgUrl)} alt={about?.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>
              {about?.title}
            </h2>
            <p className="p-text" style={{ marginTop: 10 }}>
              {about?.description}
            </p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  { tr: "hakkimda", en: "about" },
  "app__whitebg"
);
